import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../home/components/Footer';

export default function CaseCosmeticPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const monthlyData = [
    { month: 'Январь', value: 11060, label: '11 060 ₽', units: 20, comment: 'Тестовый запуск, отладка процессов' },
    { month: 'Февраль', value: 35476, label: '35 476 ₽', units: 74, comment: 'Подключение продвижения', growth: 'x3.2' },
    { month: 'Март', value: 71976, label: '71 976 ₽', units: 124, comment: 'Расширение ассортимента', growth: 'x2.0' },
    { month: 'Апрель', value: 145399, label: '145 399 ₽', units: 147, comment: 'Масштабирование, подключение FBO', growth: 'x2.0', highlight: true },
  ];

  const maxValue = Math.max(...monthlyData.map(d => d.value));

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 border-2 border-[#C5A880]/20 rounded-full -mr-48 -mt-48"></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 border-2 border-[#C5A880]/20 rounded-full -ml-36 -mb-36"></div>
        <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-[#C5A880]/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <Link
            to="/#cases"
            className="inline-flex items-center gap-2 text-[#C5A880] hover:text-white transition-colors mb-8 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg"></i>
            <span className="text-sm font-medium font-['Montserrat']">Назад к кейсам</span>
          </Link>

          <div className="inline-block bg-[#C5A880] text-[#1A2B4C] px-5 py-2 rounded-full text-base font-bold mb-6 shadow-lg font-['Montserrat']">
            🌿 Кейс: Сайт + Контекст + Ozon
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight font-['Playfair_Display']">
            Симбиоз продающего сайта,<br />контекстной рекламы и Ozon
          </h1>
          <p className="text-[#C5A880]/90 text-xl mt-2 mb-10 font-['Montserrat']">
            Интернет-магазин лечебной грязи и натуральной косметики • Январь — Апрель 2023
          </p>

          {/* Key stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { icon: 'ri-line-chart-line', label: 'Рост выручки', value: 'в 13 раз' },
              { icon: 'ri-calendar-check-line', label: 'Период', value: '4 месяца' },
              { icon: 'ri-shopping-cart-line', label: 'Продаж за период', value: '365 шт' },
              { icon: 'ri-money-dollar-circle-line', label: 'Итоговая выручка', value: '263 911 ₽' },
            ].map((stat, i) => (
              <div key={i} className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 text-center border border-[#C5A880]/20 hover:border-[#C5A880]/40 transition-all duration-300">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                  <i className={`${stat.icon} text-2xl text-[#C5A880]`}></i>
                </div>
                <div className="text-2xl font-bold text-white font-['Playfair_Display']">{stat.value}</div>
                <div className="text-[#C5A880]/80 text-sm mt-1 font-['Montserrat']">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">

          {/* Result Badge */}
          <div className="text-center mb-16">
            <div className="inline-block bg-gradient-to-r from-[#1A2B4C] to-[#0F1A2E] text-white px-8 py-5 rounded-2xl shadow-xl border border-[#C5A880]/30">
              <div className="text-sm font-medium mb-1 opacity-90 font-['Montserrat']">Ключевой результат</div>
              <div className="text-3xl font-bold text-[#C5A880] font-['Playfair_Display']">Рост выручки в 13 раз за 4 месяца</div>
              <div className="text-base mt-1 opacity-90 font-['Montserrat']">Выход уникального продукта в ТОП поиска Ozon</div>
            </div>
          </div>

          {/* Point A + Period */}
          <div className="grid md:grid-cols-2 gap-6 mb-16">
            <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-[#C5A880]/30 hover:border-[#C5A880] transition-all duration-300">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#1A2B4C] rounded-full flex items-center justify-center">
                  <i className="ri-flag-line text-xl text-[#C5A880]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1A2B4C] font-['Playfair_Display']">📍 Точка старта и Задача</h3>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed mb-4 font-['Montserrat']">
                Нам нужно было создать продающий сайт. Была проделана работа по разработке целевой аудитории, изучение продукта, далее прототипирование сайта.
              </p>
              <div className="bg-[#F8F9FA] border border-[#C5A880]/30 rounded-lg p-3 mb-4">
                <p className="text-sm text-gray-700 font-['Montserrat']">
                  <strong>Готовый сайт:</strong>{' '}
                  <a
                    href="https://smv-shop.ru/"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-[#1A2B4C] hover:text-[#C5A880] underline transition-colors"
                  >
                    https://smv-shop.ru/
                  </a>
                </p>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed font-['Montserrat']">
                Затем для масштабирования бизнеса и охвата новой аудитории было принято стратегическое решение выйти на маркетплейс Ozon, используя узнаваемость бренда и экспертный контент с сайта.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-[#C5A880]/30 hover:border-[#C5A880] transition-all duration-300">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#1A2B4C] rounded-full flex items-center justify-center">
                  <i className="ri-calendar-line text-xl text-[#C5A880]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1A2B4C] font-['Playfair_Display']">Период работы</h3>
              </div>
              <div className="text-center mt-6">
                <div className="text-4xl font-bold text-[#C5A880] mb-3 font-['Playfair_Display']">4 месяца</div>
                <p className="text-gray-600 text-sm font-['Montserrat']">Январь 2023 — Апрель 2023</p>
                <p className="text-xs text-gray-500 mt-2 font-['Montserrat']">От запуска до масштабирования</p>
              </div>
              <div className="mt-6 grid grid-cols-2 gap-3">
                <div className="bg-[#F8F9FA] border border-[#C5A880]/30 rounded-xl p-3 text-center">
                  <div className="text-lg font-bold text-[#1A2B4C] font-['Playfair_Display']">FBS → FBO</div>
                  <div className="text-xs text-gray-500 mt-1 font-['Montserrat']">Модель логистики</div>
                </div>
                <div className="bg-[#F8F9FA] border border-[#C5A880]/30 rounded-xl p-3 text-center">
                  <div className="text-lg font-bold text-[#1A2B4C] font-['Playfair_Display']">Ozon</div>
                  <div className="text-xs text-gray-500 mt-1 font-['Montserrat']">Площадка</div>
                </div>
              </div>
            </div>
          </div>

          {/* Strategy */}
          <div className="bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] rounded-2xl p-8 md:p-12 text-white mb-16 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 border-2 border-[#C5A880]/10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 border-2 border-[#C5A880]/10 rounded-full -ml-24 -mb-24"></div>
            
            <div className="relative z-10">
              <h2 className="text-3xl font-bold mb-4 text-center font-['Playfair_Display']">
                ⚙️ Подготовка и Стратегия выхода на маркетплейс Ozon
              </h2>
              <p className="text-xl text-[#C5A880]/90 text-center mb-10 font-['Montserrat']">
                Перед запуском была проведена фундаментальная работа, обеспечившая быстрый старт
              </p>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-[#C5A880]/30 hover:bg-white/15 transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-shopping-bag-line text-2xl text-[#1A2B4C]"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold mb-2 font-['Playfair_Display']">Продуктовая матрица</h4>
                      <ul className="space-y-1 text-sm text-white/90 font-['Montserrat']">
                        <li>• <strong>Старт:</strong> Запуск с основных позиций («локомотивов»): лечебная грязь в фасовке 700 г, 1 кг, 1.3 кг и ведерко 12 кг</li>
                        <li>• <strong>Развитие:</strong> Постепенно ассортимент расширялся новинками: баттер для тела, противовоспалительное и омолаживающее мыло с грязью, твердый шампунь</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-[#C5A880]/30 hover:bg-white/15 transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-user-heart-line text-2xl text-[#1A2B4C]"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold mb-2 font-['Playfair_Display']">Целевая аудитория</h4>
                      <ul className="space-y-1 text-sm text-white/90 font-['Montserrat']">
                        <li>• <strong>Сегмент 1:</strong> Люди, заботящиеся о красоте и продлении молодости</li>
                        <li>• <strong>Сегмент 2:</strong> Люди, ищущие решения для лечения заболеваний и реабилитации</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-[#C5A880]/30 hover:bg-white/15 transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-image-line text-2xl text-[#1A2B4C]"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold mb-2 font-['Playfair_Display']">Контент и Визуал</h4>
                      <ul className="space-y-1 text-sm text-white/90 font-['Montserrat']">
                        <li>• <strong>Экспертность:</strong> Информация о свойствах грязи подготовлена совместно с медиками реабилитационного центра</li>
                        <li>• <strong>Дизайн:</strong> Инфографика по воронке продаж (Внимание → Интерес → Желание → Действие)</li>
                        <li>• <strong>SEO:</strong> Продающие описания с ключевыми словами и инструкциями по применению</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-[#C5A880]/30 hover:bg-white/15 transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-calculator-line text-2xl text-[#1A2B4C]"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold mb-2 font-['Playfair_Display']">Юнит-экономика</h4>
                      <p className="text-sm text-white/90 font-['Montserrat']">
                        Рассчитана юнит-экономика специально для Ozon, чтобы учесть все расходы, логистику и получить прибыль с каждой единицы товара.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Infographics */}
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-[#C5A880]/30">
                <h4 className="text-xl font-bold mb-4 text-center font-['Playfair_Display']">
                  📸 Пример готовой инфографики — товар «Лечебная грязь»
                </h4>
                <p className="text-sm text-white/90 text-center mb-6 font-['Montserrat']">
                  Каждый слайд выстроен по воронке продаж: от привлечения внимания до закрытия возражений
                </p>
                <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                  {[
                    { src: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/29e2e6571c48be96b9872d40c774fa24.png', label: 'рис. 1' },
                    { src: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/718f064e9cc55b5af21dbc26c8ae90e3.png', label: 'рис. 2' },
                    { src: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/07a5da9febad95874de1316a624a51ee.png', label: 'рис. 3' },
                    { src: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/d8a4463da0c53dc93e1c64b2fe1fb022.png', label: 'рис. 4' },
                    { src: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/c533d873ab940a2a1dc05ea552e13ba2.png', label: 'рис. 5' },
                  ].map((slide, i) => (
                    <div key={i} className="bg-white rounded-lg overflow-hidden shadow-md border-2 border-[#C5A880]/30">
                      <img
                        src={slide.src}
                        alt={`Инфографика лечебной грязи - ${slide.label}`}
                        className="w-full h-auto object-contain"
                      />
                      <div className="p-2 bg-[#C5A880] text-center">
                        <p className="text-xs font-bold text-[#1A2B4C] font-['Montserrat']">{slide.label}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Logistics */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-[#1A2B4C] mb-4 text-center font-['Playfair_Display']">
              📦 Логистика
            </h2>
            <p className="text-center text-gray-600 mb-10 text-lg font-['Montserrat']">
              Двухэтапная модель для контроля качества и масштабирования
            </p>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-[#C5A880]/30 hover:border-[#C5A880] transition-all duration-300">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-[#1A2B4C] rounded-full flex items-center justify-center">
                    <i className="ri-store-line text-xl text-[#C5A880]"></i>
                  </div>
                  <h4 className="text-xl font-bold text-[#1A2B4C] font-['Playfair_Display']">Этап 1 — FBS</h4>
                </div>
                <p className="text-gray-700 text-sm leading-relaxed font-['Montserrat']">
                  Продажи стартовали с собственного склада (FBS). Это было необходимо для контроля качества упаковки хрупкого товара (ведерки, косметика) и отработки всех процессов.
                </p>
                <div className="mt-4 bg-[#F8F9FA] border border-[#C5A880]/30 rounded-xl p-3 text-center">
                  <span className="text-[#C5A880] font-bold text-sm font-['Montserrat']">Январь — Март 2023</span>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-[#C5A880]/30 hover:border-[#C5A880] transition-all duration-300">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-[#1A2B4C] rounded-full flex items-center justify-center">
                    <i className="ri-truck-line text-xl text-[#C5A880]"></i>
                  </div>
                  <h4 className="text-xl font-bold text-[#1A2B4C] font-['Playfair_Display']">Этап 2 — FBO</h4>
                </div>
                <p className="text-gray-700 text-sm leading-relaxed font-['Montserrat']">
                  С ростом оборотов в апреле начались поставки на склады Ozon (FBO), что ускорило доставку до клиента и повысило позиции в выдаче.
                </p>
                <div className="mt-4 bg-[#F8F9FA] border border-[#C5A880]/30 rounded-xl p-3 text-center">
                  <span className="text-[#C5A880] font-bold text-sm font-['Montserrat']">Апрель 2023 — настоящее время</span>
                </div>
              </div>
            </div>
          </div>

          {/* Promotion */}
          <div className="bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] rounded-2xl p-8 md:p-12 text-white mb-16 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 border-2 border-[#C5A880]/10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 border-2 border-[#C5A880]/10 rounded-full -ml-24 -mb-24"></div>
            
            <div className="relative z-10">
              <h2 className="text-3xl font-bold mb-4 text-center font-['Playfair_Display']">
                🚀 Продвижение: Комплексный подход
              </h2>
              <p className="text-xl text-[#C5A880]/90 text-center mb-10 font-['Montserrat']">
                Мощный микс инструментов для «раскачки» карточек и синергии каналов
              </p>

              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-[#C5A880]/30 hover:bg-white/15 transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-store-2-line text-2xl text-[#1A2B4C]"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold mb-2 font-['Playfair_Display']">Внутреннее продвижение Ozon</h4>
                      <ul className="space-y-1 text-sm text-white/90 font-['Montserrat']">
                        <li>• Участие в глобальных акциях маркетплейса</li>
                        <li>• Рекламные кампании «Трафареты» и «Продвижение в поиске»</li>
                        <li>• Рассылка бонусов и писем потенциальным покупателям</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-[#C5A880]/30 hover:bg-white/15 transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-advertisement-line text-2xl text-[#1A2B4C]"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold mb-2 font-['Playfair_Display']">Внешнее продвижение</h4>
                      <ul className="space-y-1 text-sm text-white/90 font-['Montserrat']">
                        <li>• Запуск контекстной рекламы (Яндекс, Google) на бренд</li>
                        <li>• <strong>Эффект синергии:</strong> люди видели рекламу в поиске, переходили на сайт или искали знакомый бренд на удобном им маркетплейсе</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Synergy Diagram */}
              <div className="mt-8 bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-[#C5A880]/30">
                <h4 className="text-lg font-bold mb-6 text-center font-['Playfair_Display']">💡 Схема синергии каналов</h4>
                <div className="flex items-center justify-center gap-4 flex-wrap">
                  <div className="bg-white/20 border border-[#C5A880]/30 rounded-xl p-4 text-center min-w-32">
                    <i className="ri-search-line text-3xl text-[#C5A880] mb-2 block"></i>
                    <div className="text-sm font-bold font-['Montserrat']">Контекстная<br />реклама</div>
                  </div>
                  <i className="ri-arrow-right-line text-2xl text-[#C5A880]"></i>
                  <div className="bg-white/20 border border-[#C5A880]/30 rounded-xl p-4 text-center min-w-32">
                    <i className="ri-global-line text-3xl text-[#C5A880] mb-2 block"></i>
                    <div className="text-sm font-bold font-['Montserrat']">Сайт<br />smv-shop.ru</div>
                  </div>
                  <i className="ri-add-line text-2xl text-[#C5A880]"></i>
                  <div className="bg-white/20 border border-[#C5A880]/30 rounded-xl p-4 text-center min-w-32">
                    <i className="ri-store-2-line text-3xl text-[#C5A880] mb-2 block"></i>
                    <div className="text-sm font-bold font-['Montserrat']">Магазин<br />на Ozon</div>
                  </div>
                  <i className="ri-arrow-right-line text-2xl text-[#C5A880]"></i>
                  <div className="bg-[#C5A880]/20 border-2 border-[#C5A880] rounded-xl p-4 text-center min-w-32">
                    <i className="ri-trophy-line text-3xl text-[#C5A880] mb-2 block"></i>
                    <div className="text-sm font-bold text-[#C5A880] font-['Montserrat']">Рост<br />в 13 раз</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Results */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-[#1A2B4C] mb-4 text-center font-['Playfair_Display']">
              📊 Результаты в цифрах (Динамика роста)
            </h2>
            <p className="text-center text-gray-600 mb-10 text-lg font-['Montserrat']">
              Благодаря системному подходу магазин показал взрывной рост продаж всего за 4 месяца. Выручка выросла более чем в 13 раз.
            </p>

            {/* Monthly Table */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden mb-10 border-2 border-[#C5A880]/30">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-gradient-to-r from-[#1A2B4C] to-[#0F1A2E] text-white">
                      <th className="px-6 py-4 text-left font-bold font-['Playfair_Display']">Месяц</th>
                      <th className="px-6 py-4 text-right font-bold font-['Playfair_Display']">Выручка (руб.)</th>
                      <th className="px-6 py-4 text-right font-bold font-['Playfair_Display']">Продаж (шт.)</th>
                      <th className="px-6 py-4 text-left font-bold font-['Playfair_Display']">Комментарий</th>
                    </tr>
                  </thead>
                  <tbody>
                    {monthlyData.map((row, i) => (
                      <tr
                        key={i}
                        className={`border-b border-gray-100 transition-colors ${row.highlight ? 'bg-[#C5A880]/10 border-[#C5A880]/30' : 'hover:bg-[#F8F9FA]'}`}
                      >
                        <td className="px-6 py-4 font-semibold text-[#1A2B4C] font-['Montserrat']">{row.month}</td>
                        <td className="px-6 py-4 text-right font-bold text-[#C5A880] text-lg font-['Playfair_Display']">
                          {row.label}
                        </td>
                        <td className="px-6 py-4 text-right text-gray-700 font-['Montserrat']">{row.units}</td>
                        <td className="px-6 py-4 text-sm text-gray-600 font-['Montserrat']">
                          {row.growth && (
                            <span className="bg-[#C5A880]/20 text-[#1A2B4C] border border-[#C5A880]/30 px-2 py-1 rounded-full text-xs font-bold mr-2">
                              Рост {row.growth}
                            </span>
                          )}
                          {row.comment}
                        </td>
                      </tr>
                    ))}
                    <tr className="bg-gradient-to-r from-[#1A2B4C] to-[#0F1A2E] font-bold text-white">
                      <td className="px-6 py-4 text-lg font-['Playfair_Display']">Итого</td>
                      <td className="px-6 py-4 text-right text-[#C5A880] text-xl font-['Playfair_Display']">263 911 ₽</td>
                      <td className="px-6 py-4 text-right text-lg font-['Montserrat']">365</td>
                      <td className="px-6 py-4"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Bar Chart */}
            <div className="bg-white rounded-2xl p-8 shadow-xl mb-10 border-2 border-[#C5A880]/30">
              <h3 className="text-2xl font-bold text-[#1A2B4C] mb-6 text-center font-['Playfair_Display']">
                📈 Визуализация роста выручки
              </h3>
              <div className="relative h-72 flex items-end justify-between gap-4 mb-4">
                {monthlyData.map((data, index) => (
                  <div key={index} className="flex-1 flex flex-col items-center">
                    <div className="w-full relative" style={{ height: '240px' }}>
                      <div
                        className={`absolute bottom-0 w-full ${
                          data.highlight
                            ? 'bg-gradient-to-t from-[#C5A880] to-[#1A2B4C] shadow-2xl shadow-[#C5A880]/50 border-2 border-[#C5A880]'
                            : 'bg-gradient-to-t from-[#1A2B4C] to-[#0F1A2E]'
                        } rounded-t-xl transition-all duration-500 hover:opacity-90`}
                        style={{ height: `${(data.value / maxValue) * 100}%` }}
                      >
                        <div
                          className={`absolute -top-14 left-1/2 transform -translate-x-1/2 ${
                            data.highlight
                              ? 'bg-gradient-to-r from-[#C5A880] to-[#1A2B4C] text-white scale-110 border-2 border-[#C5A880]'
                              : 'bg-[#1A2B4C] text-white border border-[#C5A880]/30'
                          } px-3 py-2 rounded-lg text-xs font-bold whitespace-nowrap shadow-xl font-['Montserrat']`}
                        >
                          {data.label}
                          <div className="text-xs opacity-80 mt-0.5">{data.units} шт</div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`text-sm mt-3 font-medium font-['Montserrat'] ${data.highlight ? 'text-[#C5A880] font-bold' : 'text-gray-600'}`}
                    >
                      {data.month}
                    </div>
                    {data.growth && (
                      <div className="text-xs text-[#C5A880] font-bold mt-1 font-['Montserrat']">↑ {data.growth}</div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Key Achievement */}
            <div className="bg-[#F8F9FA] border-2 border-[#C5A880]/30 rounded-2xl p-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#1A2B4C] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-trophy-line text-2xl text-[#C5A880]"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A2B4C] mb-3 text-xl font-['Playfair_Display']">💡 Главный итог</h3>
                  <div className="space-y-2 text-sm text-gray-700 font-['Montserrat']">
                    <p>
                      <strong>Товар «Лечебная грязь» вышел на первые страницы поиска по ключевым запросам.</strong>
                    </p>
                    <p>
                      Симбиоз сайта и маркетплейса доказал свою эффективность: сайт работает на имидж и экспертность, а Ozon — на трафик и удобство покупки для клиента.
                    </p>
                    <p className="text-[#C5A880] font-semibold">
                      Результат: Рост выручки с 11 060 ₽ до 145 399 ₽ за 4 месяца — рост в 13 раз.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center py-12 bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] rounded-3xl border-2 border-[#C5A880]/30 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-48 h-48 border-2 border-[#C5A880]/10 rounded-full -mr-24 -mt-24"></div>
            <div className="absolute bottom-0 left-0 w-40 h-40 border-2 border-[#C5A880]/10 rounded-full -ml-20 -mb-20"></div>
            
            <div className="relative z-10">
              <h2 className="text-3xl font-bold text-white mb-4 font-['Playfair_Display']">
                Хотите создать симбиоз сайта и маркетплейса для вашего бизнеса?
              </h2>
              <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto font-['Montserrat']">
                Мы знаем, как объединить все каналы в единую систему продаж и вывести уникальный продукт в топ поиска.
              </p>
              <Link
                to="/#lead-form"
                className="inline-block bg-[#C5A880] text-[#1A2B4C] px-10 py-5 rounded-full text-xl font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer font-['Montserrat']"
              >
                Создать систему продаж для моего бизнеса
              </Link>
            </div>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}